import { memo, useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { getContactPageUrl } from '../../utils/getContactPageUrl';
import { CommunicatorLogger } from 'calling-lifecycle-usage-tracker/callingTracker';
import { Link } from 'foundations-components/transitional/components/Link';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CRMEmbeddedMessage({
  subjectId,
  objectTypeId
}) {
  useEffect(() => {
    // @ts-expect-error Property 'wordpress' does not exist on type ...
    const isUsingWordPress = window.hubspot && window.hubspot.wordpress;
    if (isUsingWordPress) {
      CommunicatorLogger.log('callingInteraction', {
        action: 'WordPress user: click call icon'
      });
    }
  }, []);
  return /*#__PURE__*/_jsx(Popover, {
    marginInline: "auto",
    children: /*#__PURE__*/_jsxs(View, {
      inlineSize: "320px",
      textAlign: "center",
      paddingInline: "100",
      marginBlock: "200",
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-300",
        marginBlockEnd: "200",
        marginBlockStart: "0",
        display: "block",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "crmEmbeddedMessage.title"
        })
      }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "crmEmbeddedMessage.body_jsx",
        elements: {
          UILink: Link
        },
        options: {
          href: getContactPageUrl(subjectId, objectTypeId),
          target: '_blank',
          rel: 'noopener noreferrer'
        }
      })]
    })
  });
}
export default /*#__PURE__*/memo(CRMEmbeddedMessage);